module.exports = __webpack_public_path__ + "img/jinrong-bg-1.43ede543.png";